import Vue from 'vue';
import VueModal from 'vue-js-modal';
import { i18n, loadDefaultLanguage } from '@v4/locale/async';
import Header from '@v4/header';
import ComparePage from '@v4/compare/components/pages/ComparePage.vue';
import dataLayerHandler from '@v4/common/components/mixins/data-layer-handler';
import { LIST_COMPARE_PAGE } from '@v4/common/utils/data-layer';
// @TODO Remove when PHP template will be ready
import CompareTable from '@v4/compare/components/organisms/CompareTable.vue';
import smoothscroll from 'smoothscroll-polyfill';
import DsPollingWrapper from '@v4/common/components/molecules/DsPollingWrapper';
import '@v4/common/utils/lazy-load';

smoothscroll.polyfill();

(async () => {
    await loadDefaultLanguage();

    if (document.getElementById('single-carcompare-app')) {
        Vue.use(VueModal, { dynamic: true, injectModalsContainer: true });

        new Vue({
            el: '#single-carcompare-app',
            name: 'ComparePageWrapper',
            i18n,
            components: {
                ComparePage,
                CompareTable,
                DsPollingWrapper,
                DkButton: () => ({
                    component: import(/* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton'),
                }),
                DkCompareVehicleCard: () => ({
                    component: import(
                        /* webpackChunkName: "DkCompareVehicleCard-vue" */ '@v4/common/components/organisms/DkCompareVehicleCard'
                    ),
                }),
            },
            mixins: [dataLayerHandler],
            methods: {
                onCardCompareClick(comparisonItems) {
                    if (comparisonItems && comparisonItems.length) {
                        this.pushProductClickToDataLayer(comparisonItems, { list: LIST_COMPARE_PAGE });
                    }
                },
            },
        });
    }

    if (document.getElementById('header')) {
        Header();
    }
})();
